var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPolicy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.984 8.6h5.544l-5.544-5.496zm3 5.016V11.6H8.016v2.016zm0 3.984v-2.016H8.016V17.6zM14.016 1.616l6 6v12q0 .816-.6 1.392T18 21.584H6a1.98 1.98 0 0 1-1.416-.576 1.86 1.86 0 0 1-.6-1.392l.048-16.032q0-.816.576-1.392A1.9 1.9 0 0 1 6 1.616z",
  clipRule: "evenodd"
})));
export default SvgPolicy;